"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgChannelMobile = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgChannelMobile = function SvgChannelMobile(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fill: "url(#sc_mobile__paint0_linear)",
    d: "M0 0h120v120H0z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M73.586 20H46.559c-4.594 0-8.498 3.746-8.498 8.34v63.33c0 4.593 3.821 8.33 8.416 8.33l27.07-.03c4.595 0 8.353-3.737 8.353-8.33l.04-63.305C81.938 23.725 78.198 20 73.585 20zm-17.418 5h7.841a1.25 1.25 0 010 2.5h-7.84a1.25 1.25 0 110-2.5zm-4.712.398c.464-.463 1.307-.469 1.77 0 .231.231.369.556.369.888a1.263 1.263 0 01-1.25 1.25 1.28 1.28 0 01-.889-.37 1.262 1.262 0 010-1.768zm8.38 72.124a3.745 3.745 0 01-3.74-3.74 3.744 3.744 0 013.74-3.74 3.744 3.744 0 013.74 3.74 3.745 3.745 0 01-3.74 3.74zM78.06 87.5H42.435V31.875H78.06V87.5z",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "sc_mobile__paint0_linear",
    x1: 60,
    y1: 0,
    x2: 60,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#8B13E4"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: 1,
    stopColor: "#3D0087"
  }))));
};

exports.SvgChannelMobile = SvgChannelMobile;